import { render, staticRenderFns, recyclableRender, components } from "./details-entry.vue?vue&type=template&id=1ce3ee54&scoped=true&"
var renderjs
import script from "./details-entry.vue?vue&type=script&lang=js&"
export * from "./details-entry.vue?vue&type=script&lang=js&"
import style0 from "./details-entry.vue?vue&type=style&index=0&id=1ce3ee54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3ee54",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details-entry/details-entry.vue"
export default component.exports